<template>
  <div class="ProductGuideLayout">
    <Container class="container">
      <div class="withSidebar">
        <div class="staticSidebar">
          <div class="slider">
            <slot name="sidebar" />
          </div>
        </div>
        <div>
          <slot />
        </div>
      </div>
      <slot name="bottom" />
    </Container>
    <div class="floatingSidebar">
      <CollapsibleBar>
        <slot name="sidebar" />
      </CollapsibleBar>
    </div>
  </div>
</template>

<script>
import BasicHero from '../shared/BasicHero.vue'
import CollapsibleBar from './CollapsibleBar.vue'

export default {
  components: {
    BasicHero,
    CollapsibleBar,
  },
}
</script>

<style scoped>

.ProductGuideLayout {
  display: grid;
}

.withSidebar,
.floatingSidebar {
  grid-row: 1;
  grid-column: 1;
}

.floatingSidebar {
  position: sticky;
  top: 0;
}

.staticSidebar {
  display: none;
}

.staticSidebar .slider {
  position: sticky;
  top: var(--spacing-8);
}

.container {
  padding-top: var(--spacing-11);
  padding-bottom: var(--spacing-17);
  max-width: 100vw;  /* prevents page width being pushed out by code blocks */
}

@media (--screen-lg) {

  .withSidebar {
    display: grid;
    gap: var(--spacing-7);
    /* Using minmax here prevents column width being pushed out by contents */
    grid-template-columns: minmax(0, 1fr) minmax(0, 3fr);
  }

  .floatingSidebar {
    display: none;
  }

  .staticSidebar {
    display: block;
  }
}
</style>
